import React from 'react';
import { Wallet } from 'lucide-react';
import { ABLE_COLORS } from '../../constants';

/**
 * Widget for Money domain navigation card
 * Navigates to money view
 */
export default function MoneyCardWidget({ onNavigate }) {
  return (
    <button
      onClick={() => onNavigate && onNavigate('money')}
      style={{
        width: '100%',
        padding: '16px 12px',
        background: ABLE_COLORS.neutral,
        border: 'none',
        borderRadius: ABLE_COLORS.cardRadius,
        boxShadow: ABLE_COLORS.cardShadow,
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '6px',
        transition: 'all 0.15s ease'
      }}
    >
      <Wallet size={24} color="#10B981" />
      <span style={{
        fontSize: '13px',
        fontWeight: '600',
        color: ABLE_COLORS.textPrimary
      }}>
        Money
      </span>
      <span style={{
        fontSize: '10px',
        color: ABLE_COLORS.textMuted
      }}>
        Bills and budget
      </span>
    </button>
  );
}
